(() => {
  'use strict';
  document.documentElement.classList.add('js');
  const strings = JSON.parse(document.getElementById('orvana-strings')?.textContent || '{}');
  const msg = (key, values = {}) => String(strings[key] || '').replace(/__(\w+)__/g, (match, name) => String(values[name] ?? match));
  const normalize = (value) => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollToElement = (element) => element.scrollIntoView({behavior: reduceMotion ? 'auto' : 'smooth', block: 'start'});
  const isPreview = document.body.dataset.orvanaPreview === 'true';
  const previewRoutes = new Set(["/", "/pages/ingredients", "/pages/ingredients-cannabinoids", "/pages/ingredients-hemp-seed", "/pages/ingredients-fiber-hurd", "/pages/ingredients-plant-materials", "/pages/ingredients-cbd-isolate", "/pages/ingredients-cbg-isolate", "/pages/ingredients-cbn-ingredients", "/pages/ingredients-specialty-cannabinoids", "/pages/ingredients-broad-spectrum-extract", "/pages/ingredients-hemp-distillates", "/pages/ingredients-crystal-resistant-extract", "/pages/ingredients-cbg-rich-extract", "/pages/ingredients-specialty-hemp-extracts", "/pages/ingredients-water-dispersible-liquids", "/pages/ingredients-water-dispersible-powders", "/pages/ingredients-custom-blends", "/pages/ingredients-crude-winterized-extract", "/pages/ingredients-full-spectrum-extract", "/pages/ingredients-cbda-rich-live-resin", "/pages/ingredients-hemp-seed-oil", "/pages/ingredients-hemp-hearts-seed", "/pages/ingredients-hemp-protein-flour-fiber", "/pages/ingredients-other-seed-fractions", "/pages/ingredients-hydrolyzed-hemp-seed-protein", "/pages/ingredients-hemp-seed-oil-powder", "/pages/ingredients-hemp-seed-pastes-bases", "/pages/ingredients-hemp-cosmetic-butters-blends", "/pages/ingredients-hemp-derived-terpenes", "/pages/ingredients-hemp-bast-fiber", "/pages/ingredients-hemp-hurd", "/pages/ingredients-milled-hemp-stalk", "/pages/ingredients-hemp-sliver-roving", "/pages/ingredients-hemp-yarns", "/pages/ingredients-hemp-pulp", "/pages/ingredients-hemp-composite-pellets", "/pages/ingredients-hemp-biochar", "/pages/ingredients-hemp-biomass", "/pages/ingredients-hemp-trim-shake", "/pages/ingredients-hemp-flower-for-processing", "/pages/ingredients-hemp-stalks-straw", "/pages/ingredients-hemp-leaf-juice-powder", "/pages/how-it-works", "/pages/samples", "/pages/quality", "/pages/delivery", "/pages/destinations", "/pages/about", "/pages/quote", "/pages/privacy", "/pages/terms", "/404"]);
  const nativeContentRoutes = new Set(['/pages/quote', '/pages/privacy']);
  const currentLocation = () => isPreview && location.hash.startsWith('#/') ? new URL(location.hash.slice(1), location.origin) : new URL(location.href);
  const currentQuery = () => currentLocation().search;
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const header = document.querySelector('.site-header');
  if (menuToggle && mobileMenu) {
    const setMenu = (open, restoreFocus = false) => {
      menuToggle.setAttribute('aria-expanded', String(open));
      menuToggle.setAttribute('aria-label', open ? msg('close_navigation') : msg('open_navigation'));
      mobileMenu.hidden = !open;
      mobileMenu.classList.toggle('hidden', !open);
      if (!open && restoreFocus) menuToggle.focus();
    };
    setMenu(false);
    menuToggle.addEventListener('click', () => setMenu(menuToggle.getAttribute('aria-expanded') !== 'true'));
    mobileMenu.addEventListener('click', (event) => {
      if (event.target.closest('a')) setMenu(false);
    });
    document.addEventListener('click', (event) => {
      if (menuToggle.getAttribute('aria-expanded') === 'true' && !(header || mobileMenu).contains(event.target) && !menuToggle.contains(event.target)) setMenu(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menuToggle.getAttribute('aria-expanded') === 'true') setMenu(false, true);
    });
    const desktop = window.matchMedia('(min-width: 961px)');
    const closeAtDesktop = (event) => { if (event.matches) setMenu(false); };
    if (desktop.addEventListener) desktop.addEventListener('change', closeAtDesktop);
    else if (desktop.addListener) desktop.addListener(closeAtDesktop);
  }

  const navMenus = Array.from(document.querySelectorAll('.nav-menu'));
  navMenus.forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (menu.open) navMenus.forEach((other) => { if (other !== menu) other.open = false; });
    });
  });
  document.addEventListener('click', (event) => navMenus.forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  }));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    navMenus.forEach((menu) => {
      if (!menu.open) return;
      const hadFocus = menu.contains(document.activeElement);
      menu.open = false;
      if (hadFocus) menu.querySelector('summary')?.focus();
    });
  });


  const initializePage = () => {
  const heroSearch = document.getElementById('hero-search');
  if (heroSearch) {
    heroSearch.setAttribute('action', '/pages/ingredients');
    heroSearch.setAttribute('method', 'get');
    const heroQuery = heroSearch.querySelector('input[name="q"], input[type="search"]');
    if (heroQuery) heroQuery.name = 'q';
  }

  const search = document.getElementById('ingredient-search');
  if (search) {
    const directoryQuery = new URLSearchParams(currentQuery()).get('q');
    if (directoryQuery !== null) search.value = directoryQuery.slice(0, 200);
  }
  const cards = Array.from(document.querySelectorAll('.catalog-grid .ingredient-card'));
  const filterButtons = Array.from(document.querySelectorAll('.filter-tabs button[data-filter]'));
  if (cards.length) {
    let activeFilter = normalize(filterButtons.find((button) => button.getAttribute('aria-pressed') === 'true')?.dataset.filter || 'all');
    const resultCount = document.getElementById('result-count');
    const noResults = document.getElementById('no-results');
    const searchableCards = cards.map((card) => ({ card, family: normalize(card.dataset.family), searchText: normalize(`${card.dataset.search || ''} ${card.textContent || ''}`) }));
    const updateCatalog = () => {
      const terms = normalize(search?.value).split(' ').filter(Boolean);
      let visible = 0;
      searchableCards.forEach(({ card, family, searchText }) => {
        const families = family.split(/[,|;]+/).map((part) => part.trim());
        const familyMatches = activeFilter === 'all' || activeFilter === 'all ingredients' || families.includes(activeFilter);
        const matches = familyMatches && terms.every((term) => searchText.includes(term));
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      filterButtons.forEach((button) => button.setAttribute('aria-pressed', String(normalize(button.dataset.filter) === activeFilter)));
      if (resultCount) resultCount.textContent = msg('results_shown', {count: visible, ingredient: msg(visible === 1 ? 'ingredient_singular' : 'ingredient_plural')});
      if (noResults) {
        noResults.hidden = visible !== 0;
        const inquiryLink = noResults.querySelector('a');
        if (inquiryLink) inquiryLink.setAttribute('href', '/pages/quote?product=' + encodeURIComponent(search?.value.trim() || msg('other_ingredient')));
      }
    };
    search?.addEventListener('input', updateCatalog);
    search?.addEventListener('search', updateCatalog);
    filterButtons.forEach((button) => button.addEventListener('click', () => {
      activeFilter = normalize(button.dataset.filter || 'all');
      updateCatalog();
    }));
    updateCatalog();
  }

  const nativeInquiryForm = document.getElementById('orvana-inquiry-form');
  if (nativeInquiryForm) {
    const nativeQuery = new URLSearchParams(currentQuery());
    const nativeIntent = nativeInquiryForm.elements.namedItem('contact[Inquiry type]');
    const requestedIntent = nativeQuery.get('intent');
    if (nativeIntent && ['quote', 'sample', 'general'].includes(requestedIntent)) nativeIntent.value = requestedIntent;
    const populateNativeField = (name, value) => {
      const field = nativeInquiryForm.elements.namedItem(name);
      if (!field || !value || field.value) return;
      const safeValue = String(value).trim().slice(0, 200);
      if (field.tagName === 'SELECT') {
        const option = Array.from(field.options).find((item) => normalize(item.value) === normalize(safeValue) || normalize(item.textContent) === normalize(safeValue));
        if (option) field.value = option.value;
        else {
          const newOption = document.createElement('option');
          newOption.value = safeValue;
          newOption.textContent = safeValue;
          field.append(newOption);
          field.value = safeValue;
        }
      } else field.value = safeValue;
    };
    populateNativeField('contact[Ingredient]', nativeQuery.get('product'));
    populateNativeField('contact[Destination country]', nativeQuery.get('country'));
    const nativeStatus = document.getElementById('orvana-inquiry-errors') || document.getElementById('orvana-inquiry-success');
    if (nativeStatus) nativeStatus.focus({preventScroll: false});
  }

  const form = document.getElementById('inquiry-form');
  if (!form) return;
  const intentButtons = Array.from(document.querySelectorAll('.intent-tabs button[data-intent]'));
  const intentInput = document.getElementById('inquiry-intent') || form.elements.namedItem('intent');
  const fieldByNames = (names) => Array.from(form.elements).find((field) => names.some((name) => normalize(field.name) === normalize(name)) && field.type !== 'submit');
  const fields = {
    name: fieldByNames(['name', 'fullName', 'full_name', 'contactName']),
    company: fieldByNames(['company', 'companyName', 'company_name']),
    email: fieldByNames(['email', 'businessEmail', 'business_email']),
    ingredient: fieldByNames(['ingredient', 'product']),
    destination: fieldByNames(['destination', 'country', 'destinationCountry']),
    intendedUse: fieldByNames(['intendedUse', 'intended_use', 'use']),
    quantity: fieldByNames(['quantity', 'volume']),
    unit: fieldByNames(['unit', 'quantityUnit']),
    frequency: fieldByNames(['frequency', 'orderFrequency']),
    message: fieldByNames(['message', 'requirements', 'notes'])
  };
  const productFields = ['ingredient', 'destination', 'intendedUse', 'quantity', 'unit', 'frequency'];
  const updateIntentFields = () => {
    const general = normalize(intentInput?.value) === 'general';
    form.querySelectorAll('[data-product-field]').forEach((wrapper) => {
      wrapper.hidden = general;
      wrapper.querySelectorAll('input, select, textarea').forEach((field) => { field.disabled = general; });
    });
    productFields.forEach((key) => { if (fields[key]) fields[key].disabled = general; });
    ['name', 'company', 'email'].forEach((key) => { if (fields[key]) fields[key].required = true; });
    if (fields.ingredient) fields.ingredient.required = !general;
    if (fields.destination) fields.destination.required = false;
    if (fields.intendedUse) fields.intendedUse.required = false;
    if (fields.message) {
      fields.message.required = general;
      const label = fields.message.closest('label');
      if (label?.firstChild?.nodeType === 3) label.firstChild.textContent = general ? msg('message_required') : msg('message_optional');
    }
    Object.values(fields).forEach((field) => {
      if (!field) return;
      field.setAttribute('aria-required', String(field.required && !field.disabled));
      field.setCustomValidity('');
    });
  };
  const setIntent = (value) => {
    const button = intentButtons.find((item) => normalize(item.dataset.intent) === normalize(value));
    if (!button && intentButtons.length) return false;
    if (intentInput) intentInput.value = button ? button.dataset.intent : value;
    intentButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    updateIntentFields();
    return true;
  };
  intentButtons.forEach((button) => button.addEventListener('click', () => setIntent(button.dataset.intent)));
  const initialIntent = intentInput?.value || intentButtons.find((button) => button.getAttribute('aria-pressed') === 'true')?.dataset.intent || intentButtons[0]?.dataset.intent || 'Quote';
  setIntent(initialIntent);

  const prefill = (field, value) => {
    if (!field || !value) return;
    const safeValue = String(value).trim().slice(0, 200);
    if (field.tagName === 'SELECT') {
      const option = Array.from(field.options).find((item) => normalize(item.value) === normalize(safeValue) || normalize(item.textContent) === normalize(safeValue));
      if (option) field.value = option.value;
      else {
        const newOption = document.createElement('option');
        newOption.value = safeValue;
        newOption.textContent = safeValue;
        field.append(newOption);
        field.value = safeValue;
      }
    } else field.value = safeValue;
  };
  const query = new URLSearchParams(currentQuery());
  prefill(fields.ingredient, query.get('product'));
  prefill(fields.destination, query.get('country'));
  if (query.get('intent')) setIntent(query.get('intent'));
  form.querySelectorAll('[data-requires-js]').forEach((element) => { element.disabled = false; });

  let reviewPanel = document.getElementById('request-review');
  if (!reviewPanel) {
    reviewPanel = document.createElement('section');
    reviewPanel.id = 'request-review';
    reviewPanel.className = 'review-panel';
    reviewPanel.hidden = true;
    form.after(reviewPanel);
  }
  reviewPanel.classList.add('review-panel');
  let reviewHeading = reviewPanel.querySelector('h2, h3');
  if (!reviewHeading) {
    reviewHeading = document.createElement('h2');
    reviewPanel.prepend(reviewHeading);
  }
  reviewHeading.textContent = msg('review_heading');
  reviewHeading.id = reviewHeading.id || 'review-heading';
  reviewHeading.tabIndex = -1;
  reviewPanel.setAttribute('aria-labelledby', reviewHeading.id);
  let reviewStatus = reviewPanel.querySelector('.review-status') || Array.from(reviewPanel.querySelectorAll('p')).find((paragraph) => paragraph.textContent.trim().startsWith('Not sent.'));
  if (!reviewStatus) {
    reviewStatus = document.createElement('p');
    reviewStatus.className = 'review-status';
    reviewHeading.after(reviewStatus);
  }
  reviewStatus.classList.add('review-status');
  reviewStatus.textContent = msg('not_sent_intro');
  let reviewContent = document.getElementById('review-content');
  if (!reviewContent) {
    reviewContent = document.createElement('div');
    reviewContent.id = 'review-content';
    reviewPanel.append(reviewContent);
  }
  reviewContent.classList.add('review-content');
  let reviewActions = reviewPanel.querySelector('.actions');
  if (!reviewActions) {
    reviewActions = document.createElement('div');
    reviewActions.className = 'actions';
    reviewPanel.append(reviewActions);
  }
  const ensureButton = (id, label, secondary) => {
    let button = document.getElementById(id);
    if (!button) {
      button = document.createElement('button');
      button.id = id;
      reviewActions.append(button);
    }
    button.textContent = label;
    button.type = 'button';
    button.classList.add('button');
    if (secondary) button.classList.add('secondary');
    return button;
  };
  const editButton = ensureButton('edit-request', msg('edit_inquiry'), true);
  const downloadButton = ensureButton('download-request', msg('download_inquiry'), true);
  const copyButton = ensureButton('copy-request', msg('copy_inquiry'), true);
  let emailLink = document.getElementById('email-request');
  if (!emailLink || emailLink.tagName !== 'A') {
    const anchor = document.createElement('a');
    anchor.id = 'email-request';
    if (emailLink) emailLink.replaceWith(anchor);
    emailLink = anchor;
  }
  emailLink.classList.add('button');
  emailLink.textContent = msg('open_email_draft');
  reviewActions.prepend(emailLink);
  emailLink.after(copyButton);
  copyButton.after(downloadButton);
  downloadButton.after(editButton);
  let copyStatus = document.getElementById('copy-status');
  if (!copyStatus) {
    copyStatus = document.createElement('p');
    copyStatus.id = 'copy-status';
    reviewActions.after(copyStatus);
  }
  copyStatus.setAttribute('role', 'status');
  copyStatus.setAttribute('aria-live', 'polite');
  copyStatus.textContent = '';
  const recipient = 'sales@orvanaglobal.com';

  const maximumMailtoLength = 1800;
  let latestReview = null;
  let latestDraftText = '';
  const displayValue = (field) => {
    if (!field || field.disabled) return '';
    if (field.tagName === 'SELECT') return field.value ? field.selectedOptions[0]?.textContent?.trim() || field.value : '';
    return String(field.value || '').trim();
  };
  const labels = [
    ['name', msg('label_name')], ['company', msg('label_company')], ['email', msg('label_email')],
    ['ingredient', msg('label_ingredient')], ['destination', msg('label_destination')],
    ['intendedUse', msg('label_use')], ['quantity', msg('label_quantity')], ['unit', msg('label_unit')],
    ['frequency', msg('label_frequency')], ['message', msg('label_notes')]
  ];
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    Object.values(fields).forEach((field) => {
      if (!field) return;
      field.setCustomValidity('');
      if (!field.disabled && field.required && !displayValue(field)) field.setCustomValidity(msg('complete_field'));
    });
    if (!form.reportValidity()) return;
    const activeIntent = intentButtons.find((button) => button.getAttribute('aria-pressed') === 'true');
    latestReview = [[msg('inquiry_type'), activeIntent?.textContent?.trim() || intentInput?.value || msg('ingredient_inquiry')]];
    labels.forEach(([key, label]) => {
      if (fields[key] && !fields[key].disabled) latestReview.push([label, displayValue(fields[key]) || msg('not_provided')]);
    });
    const list = document.createElement('dl');
    latestReview.forEach(([label, value]) => {
      const row = document.createElement('div');
      const term = document.createElement('dt');
      const definition = document.createElement('dd');
      term.textContent = label;
      definition.textContent = value;
      row.append(term, definition);
      list.append(row);
    });
    reviewContent.replaceChildren(list);
    const intentLabel = activeIntent?.textContent?.trim() || msg('business_inquiry');
    const subject = msg('email_subject', {intent: intentLabel, company: displayValue(fields.company)}).replace(/[\r\n]+/g, ' ').slice(0, 180);
    const body = [msg('email_heading'), '', ...latestReview.map(([label, value]) => `${label}: ${value}`)].join('\n');
    latestDraftText = [msg('email_to', {recipient}), msg('email_subject_line', {subject}), '', body].join('\n');
    const emailDraft = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    const longBrief = emailDraft.length > maximumMailtoLength;
    emailLink.href = longBrief ? `mailto:${recipient}?subject=${encodeURIComponent(subject)}` : emailDraft;
    emailLink.removeAttribute('aria-disabled');
    emailLink.textContent = longBrief ? msg('open_long_draft') : msg('open_email_draft');
    reviewStatus.textContent = longBrief
      ? msg('long_inquiry_status', {recipient})
      : msg('short_inquiry_status', {recipient});
    copyStatus.textContent = '';
    copyButton.disabled = false;
    downloadButton.disabled = false;
    reviewPanel.hidden = false;
    reviewPanel.classList.remove('hidden');
    reviewHeading.focus({ preventScroll: true });
    scrollToElement(reviewPanel);
  });
  editButton.addEventListener('click', () => {
    invalidateReview();
    const focusTarget = fields.name || form.querySelector('input:not([type="hidden"]), select, textarea');
    focusTarget?.focus({ preventScroll: true });
    scrollToElement(form);
  });

  const invalidateReview = () => {
    latestReview = null;
    latestDraftText = '';
    reviewPanel.hidden = true;
    emailLink.removeAttribute('href');
    emailLink.setAttribute('aria-disabled', 'true');
    copyButton.disabled = true;
    downloadButton.disabled = true;
    copyStatus.textContent = '';
  };
  form.addEventListener('input', (event) => {
    event.target.setCustomValidity?.('');
    invalidateReview();
  });
  form.addEventListener('change', invalidateReview);
  intentButtons.forEach((button) => button.addEventListener('click', invalidateReview));
  invalidateReview();
  copyButton.addEventListener('click', async () => {
    if (!latestReview || !latestDraftText) return;
    const review = latestReview;
    const text = latestDraftText;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard is unavailable');
      await navigator.clipboard.writeText(text);
      if (latestReview !== review) return;
      copyStatus.textContent = msg('copy_success', {recipient});
    } catch {
      if (latestReview !== review) return;
      copyStatus.textContent = msg('copy_failure');
    }
  });
  downloadButton.addEventListener('click', () => {
    if (!latestReview || !latestDraftText) return;
    const lines = [msg('download_heading'), '', latestDraftText];
    const blob = new Blob([lines.join('\n')], { type: 'text/plain;charset=utf-8' });
    const objectURL = URL.createObjectURL(blob);
    const downloadLink = document.createElement('a');
    downloadLink.href = objectURL;
    downloadLink.download = 'phytocura-inquiry.txt';
    downloadLink.hidden = true;
    document.body.append(downloadLink);
    downloadLink.click();
    downloadLink.remove();
    window.setTimeout(() => URL.revokeObjectURL(objectURL), 1000);
  });

  };
  const updateNavigation = () => {
    const current = currentLocation().pathname.replace(/\/$/, '') || '/';
    document.querySelectorAll('.site-header a, .site-footer a').forEach((link) => {
      const url = new URL(link.href, location.origin);
      if ((url.pathname.replace(/\/$/, '') || '/') === current && !url.search) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  };
  initializePage();
  updateNavigation();
  if (!isPreview) return;
  let manifestPromise;
  const manifest = () => manifestPromise ||= fetch(document.body.dataset.orvanaManifest, {credentials: 'same-origin'}).then((response) => {
    if (!response.ok) throw new Error('Preview content unavailable');
    return response.json();
  });
  let navigationSequence = 0;
  const renderRoute = async () => {
    if (!location.hash.startsWith('#/')) return;
    const sequence = ++navigationSequence;
    const url = currentLocation();
    if (nativeContentRoutes.has(url.pathname.replace(/\/$/, '') || '/')) {
      const nativeUrl = new URL(url.pathname + url.search, location.origin);
      const theme = new URLSearchParams(location.search).get('preview_theme_id');
      if (theme) nativeUrl.searchParams.set('preview_theme_id', theme);
      location.assign(nativeUrl.href);
      return;
    }
    try {
      const content = await manifest();
      if (sequence !== navigationSequence) return;
      const page = content[url.pathname.replace(/\/$/, '') || '/'] || content['/404'];
      const main = document.getElementById('main');
      const render = () => {
        main.innerHTML = page.html;
        document.title = page.title + ' | PhytoCura';
        initializePage();
        updateNavigation();
        document.querySelectorAll('.nav-menu[open]').forEach((item) => item.open = false);
        const menuButton = document.querySelector('.menu-toggle');
        const mobile = document.getElementById('mobile-menu');
        if (menuButton) menuButton.setAttribute('aria-expanded', 'false');
        if (mobile) { mobile.hidden = true; mobile.classList.add('hidden'); }
        window.scrollTo({top: 0, behavior: 'instant'});
        main.focus({preventScroll: true});
      };
      if (!reduceMotion && document.startViewTransition) document.startViewTransition(render);
      else render();
    } catch {
      const fallback = new URL(url.pathname + url.search, location.origin);
      const theme = new URLSearchParams(location.search).get('preview_theme_id');
      if (theme) fallback.searchParams.set('preview_theme_id', theme);
      location.assign(fallback.href);
    }
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target || link.hasAttribute('download')) return;
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:')) return;
    const url = new URL(link.href, location.origin);
    if (nativeContentRoutes.has(url.pathname.replace(/\/$/, '') || '/')) return;
    if (url.origin !== location.origin || !previewRoutes.has(url.pathname.replace(/\/$/, '') || '/')) return;
    event.preventDefault();
    location.hash = url.pathname + url.search;
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.id !== 'hero-search') return;
    event.preventDefault();
    location.hash = '/pages/ingredients?q=' + encodeURIComponent(new FormData(form).get('q') || '');
  });
  window.addEventListener('hashchange', renderRoute);
  renderRoute();
})();
